import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
  private appInsights: ApplicationInsights | undefined;

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    if (!isPlatformBrowser(this.platformId)) {
      console.log('[AppInsights] Not running in browser - initialization skipped');
      return;
    }

    const envAny: any = environment as any;
    const conn = envAny?.appInsights?.connectionString;
    const ikey = envAny?.appInsights?.instrumentationKey;

    if (conn || ikey) {
      const config: any = {
        connectionString: conn || undefined,
        instrumentationKey: ikey || undefined,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
        samplingPercentage: envAny?.appInsights?.samplingPercentage ?? 25,
        maxBatchInterval: envAny?.appInsights?.maxBatchInterval ?? 15000
      };

      this.appInsights = new ApplicationInsights({ config });
      this.appInsights.loadAppInsights();

      console.log('[AppInsights] Initialized', { connectionString: conn ? '[redacted]' : undefined, instrumentationKey: ikey ? '[redacted]' : undefined, sampling: config.samplingPercentage });

      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((event: any) => {
        console.log('[AppInsights] Router NavigationEnd -> trackPageView', event.urlAfterRedirects);
        this.appInsights?.trackPageView({ name: event.urlAfterRedirects });
      });
    }
    else {
      console.log('[AppInsights] No connectionString or instrumentationKey found in environment; telemetry disabled');
    }
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    console.log('[AppInsights] trackEvent', name, properties);
    this.appInsights?.trackEvent({ name }, properties);
  }

  logPageView(name?: string) {
    console.log('[AppInsights] trackPageView', name);
    this.appInsights?.trackPageView({ name });
  }

  logException(exception: Error, severityLevel?: number) {
    console.log('[AppInsights] trackException', exception, severityLevel);
    this.appInsights?.trackException({ exception, severityLevel });
  }
}
